import ModernAnalyticsContext from './ModernAnalyticsContext';
export default ModernAnalyticsContext;